import { host } from "@Services/url";
import React from "react";

const BuyCarMini: React.FC<any> = ({ data }) => {
  const { brandName, brandLogo, kindName, brandId, kindId } = data;

  return (
    <div className='h-[30px] items-center bg-[rgba(0,0,0,.5)] rounded-2 flex gap-4'>
      <img className='w-20 h-20 bg-[#fff] rounded-full' src={brandLogo} />
      <div className='text-[#fff] text-12 font-normal'>
        {brandName} {kindName}
      </div>
      <a
        target='_blank'
        className='text-12 px-8 text-center font-normal text-[#fff] flex hover:text-[#fff] bg-[#FF4333] rounded-4 h-24 leading-24 relative'
        href={`${host.c}/ask/price?b=${brandId}&k=${kindId}&source=短影音播放頁-播放彈窗購車菜單`}
      >
        一鍵詢價
      </a>
    </div>
  );
};

export default BuyCarMini;
